<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
      v-if="criteresRecherche">
  <div class="column is-12 pdb-0"
      :class="[
    {'hauteur-haut-brief-filtre': errors.length === 0},
    {'hauteur-haut-brief-filtre-errors': errors.length > 0}
  ]">
    <div class="column is-12" v-if="errors.length > 0">
      <error-msg-component :messages="errors"
                            :error="errors.length > 0"
                            :title="'general.problemOccurred'"
                            :withEmplyFields="true"
                            @close="errors = []"/>
    </div>
    <div class="column is-12 mgt-5px">
      <a @click="$emit('toggleFiltre')">
        <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
      </a>
      <span class="has-text-weight-bold is-size-4">
        {{ $t('listeLignesCommande.filtre.title') }}
      </span>
    </div>
    <div class="column is-12 pdt-0">
      <span class="has-text-icon-more is-size-7">
        {{ $t('listeLignesCommande.filtre.sousTitle') }}
      </span>
    </div>
  </div>
    <div
      class="column is-12 overflow-auto
      is-marginless"
      :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0">
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="criteresRecherche.tiersId"
            :societeActiveId="societeActiveId"
            :label="$t('listeDevis.filtre.client')">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLignesDevis.filtre.referenceClient')">
            <b-input v-model="criteresRecherche.referenceClient">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLignesDevis.filtre.libelleProduit')">
            <b-input v-model="criteresRecherche.libelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
            <query-tag-input
              :label="$t('listeLignesDevis.filtre.produits')"
              v-model="criteresRecherche.produitsIds"
              icon="magnify"
              autocomplete
              field="reference"
              :query="(search) => getAllProduits({
                query: {
                  auto: search,
                  categorie: categorieProduitNonPatrimonial.map(el => el.code),
                  societeId: societeActiveId,
                }
              })"
            >
              <template slot-scope="props">
                {{ props.option.reference }} - {{ props.option.libelle }}
              </template>
            </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            :label="$t('listeLignesCommande.filtre.typeProduit')"
            :items="categorieProduitNonPatrimonial"
            v-model="criteresRecherche.typesProduits">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
            <query-tag-input
              :label="$t('listeLignesDevis.filtre.patrimoine')"
              v-model="criteresRecherche.produitRegroupementIds"
              field="reference"
              autocomplete
              :query="(search) => getAllProduits({
                query: {
                  auto: search,
                  categorie: categorieProduitPatrimonial.map(el => el.code),
                  societeId: societeActiveId,
                }
              })"
            >
            <template slot-scope="props">
              {{ props.option.reference }} - {{ props.option.libelle }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            :label="$t('listeLignesDevis.filtre.typePatrimoine')"
            :items="categorieProduitPatrimonial"
            v-model="criteresRecherche.typesProduitRegroupement">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field
          v-if="modulePlanMediaActive && $route.name !== 'c.presse.plan_media'"
          :label="$t('listeLignesDevis.filtre.codePM')"
          >
            <b-input
             v-model="criteresRecherche.codePM"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLignesDevis.filtre.code')">
            <b-input v-model="criteresRecherche.code">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeLignesDevis.filtre.codeDossier')">
            <qd-taginput v-model="criteresRecherche.codesDossier"
                        icon="magnify" type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            :label="$t('listeLignesDevis.filtre.etat')"
            :items="constantes.DEVIS_ETAT"
            v-model="criteresRecherche.etatsDevisCommandeFacture">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pbd-0">
          <user-tag-input
            :label="$t('listeLignesDevis.filtre.commercial')"
            :blocked="userIsCommercialBlocked"
            v-model="criteresRecherche.commercialId"
            v-if="criteresRecherche.commercialId"
            :items="listeCommercial"
          >
          </user-tag-input>
        </div>
        <div class="column is-12 pbd-0">
          <user-tag-input
            :label="$t('listeLignesDevis.filtre.assistant')"
            v-model="criteresRecherche.assistantId"
            v-if="criteresRecherche.assistantId"
            :items="listeAssistant"
          >
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-fournisseur-tag-input
            :label="$t('listeLignesDevis.filtre.fournisseur')"
            v-model="criteresRecherche.fournisseursId"
            :societeActiveId="societeActiveId"
            :sousType="[]"
          ></query-fournisseur-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <input-periode
            v-model="criteresRecherche.datesPremierAffichage"
            orientation= 'top'
            :label="$t('listeLignesDevis.filtre.datePremierAffichage')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeLignesCommande.filtre.groupe')"
            v-model="criteresRecherche.groupeIds"
            :typologie="this.constantes.TYPOLOGIE_GROUPE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('listeLignesCommande.filtre.enseigne')"
            v-model="criteresRecherche.enseigneIds"
            :typologie="this.constantes.TYPOLOGIE_ENSEIGNE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
          <secteur-tag-input v-model="secteursSelected"
            :label="$t('listeFactures.filtre.secteur')"
            :critere="(el) => el.type === constantes.SECTEURCOMMERCIAL"
            :disabled="secteurCurrentUser.length > 0">
          </secteur-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import cloneDeep from 'lodash/cloneDeep';
import { DEVIS_ETAT, LISTE_TYPE_DEVIS_COMMANDE } from '@/configuration/devisConf';
import { SET_CRITERE } from '@/store/modules/bodac/commandeParligneCommande-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import messageErreur from '@/services/general/messageErreur';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import genererCritereLignesDevis from '@/services/bodac/devis/genererCritereLignesDevis';
import queryFournisseurTagInput from '@/components/general/tagInput/queryFournisseurTagInput';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { getAll as getAllProduits } from '@/api/produit/index';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { COMMERCIAL as SECTEURCOMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import {
  TYPOLOGIE_ENSEIGNE,
  TYPOLOGIE_GROUPE,
} from '@/configuration/tiers/tiersConf';

const LignesDevis = createNamespacedHelpers('devisParLignesDevis');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  components: {
    libelleTagInput,
    queryTagInput,
    inputPeriode,
    userTagInput,
    queryClientTagInput,
    queryFournisseurTagInput,
    queryTiersTagInput,
    secteurTagInput,
  },
  data() {
    return {
      criteresRecherche: null,
      getAllProduits,
      errors: [],
      listeCommercial: [],
      listeAssistant: [],
      constantes: {
        DEVIS_ETAT,
        LISTE_TYPE_DEVIS_COMMANDE,
        TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE,
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
        ASSISTANT_COMMERCIAL,
        SECTEURCOMMERCIAL,
      },
      secteursSelected: [],
      secteurCurrentUser: [],
    };
  },
  computed: {
    ...LignesDevis.mapGetters({
      criteresRechercheStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    categorieProduitNonPatrimonial() {
      return this.categorieProduit.filter(categorie => !categorie.patrimonial);
    },
    categorieProduitPatrimonial() {
      return this.categorieProduit.filter(categorie => categorie.patrimonial);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return (this.user.profil === COMMERCIAL);
    },
    userIsCommercialBlocked() {
      return this.userIsCommercial && this.blocageFiltreCommercial;
    },
    userIsAssistant() {
      return (this.user.profil === ASSISTANT_COMMERCIAL);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
  },
  methods: {
    ...LignesDevis.mapMutations({
      setCriteresRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.criteresRecherche = cloneDeep(this.criteresRechercheStore);
        await this.loadParametreUtilisateur();
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        ]);
        this.listeEtatBase = cloneDeep(DEVIS_ETAT);
        await updateCritereWithParametreInterne(this.criteresRecherche);
        const users = this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(user => user.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeLignesDevis.filtre.noCommercial'));
        this.criteresRecherche.commercialId = this.listeCommercial.filter((commercial) => {
          return this.criteresRecherche.commercialId.includes(commercial.id);
        });
        this.listeAssistant = initialUsers(users, [ASSISTANT_COMMERCIAL], this.$i18n.t('listeLignesCommande.filtre.sansAssistant'));
        this.criteresRecherche.assistantId = this.listeAssistant.filter((assistant) => {
          return this.criteresRecherche.assistantId.includes(assistant.id);
        });
        this.criteresRecherche.etatsDevisCommandeFacture = this.listeEtatBase
          .filter((etat) => {
            return this.criteresRecherche.etatsDevisCommandeFacture?.includes(etat.code);
          });
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        ]);
        if (this.moduleSecteurActive) {
          await this.loadParametres([PARAMETRES_KEYS.secteur]);
          this.secteurCurrentUser = await getSecteursIdByUser(SECTEURCOMMERCIAL, true);
          if (this.criteresRecherche.secteurIds.length > 0) {
            this.secteursSelected = this.secteurs.filter((s) => {
              return this.criteresRecherche.secteurIds.includes(s.id) && s.actif === true;
            });
          }
          if (this.secteurCurrentUser?.length > 0) {
            this.secteursSelected = this.secteurCurrentUser;
          }
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    appliquerCritere() {
      if (this.criteresRecherche.datesPremierAffichage.dateFin
      && this.criteresRecherche.datesPremierAffichage.dateFin
      > this.criteresRecherche.dateDebut) {
        this.errors.push({
          message: 'listeLignesDevis.filtre.error.errorDatePremierAffichage',
        });
      }
      if (this.criteresRecherche) {
        const criteresCopy = cloneDeep(this.criteresRecherche);
        criteresCopy.commercialId = this.criteresRecherche.commercialId.map(
          (commercial) => commercial.id,
        );
        criteresCopy.assistantId = this.criteresRecherche.assistantId.map(
          (assistant) => assistant.id,
        );
        criteresCopy.etatsDevisCommandeFacture = this.criteresRecherche.etatsDevisCommandeFacture
          .map(
            (etats) => etats.code,
          );
        if (this.moduleSecteurActive) {
          criteresCopy.secteurIds = this.secteursSelected.map(s => s.id);
        }
        this.setCriteresRecherche(criteresCopy);
        this.$emit('recherche');
      }
    },
    async viderCritere() {
      this.criteresRecherche = cloneDeep(genererCritereLignesDevis());
      await updateCritereWithParametreInterne(this.criteresRecherche);
      this.criteresRecherche.commercialId = this.criteresRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.criteresRecherche.etatsDevisCommandeFacture = this.listeEtatBase
        .filter((etat) => {
          return this.criteresRecherche.etatsDevisCommandeFacture?.includes(etat.code);
        });
      if (this.moduleSecteurActive) {
        this.secteursSelected = this.secteurCurrentUser ?? [];
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
